module.exports = __webpack_public_path__ + "assets/img/page4-nav-item-7-6d072562.png";